import { getSelectValue } from "src/system/getSelectValue.ts";
import { getSelectLabel } from "src/system/getSelectLabel.ts";
import type { GridValidRowModel } from "@mui/x-data-grid-premium";
import type { SelectValueProp, SelectLabelProp } from "./system.types";

export const useSelectOptions = <
  Resource extends GridValidRowModel = GridValidRowModel,
>({
  valueProp,
  labelProp,
  resources,
}: {
  valueProp?: SelectValueProp<Resource>;
  labelProp?: SelectLabelProp<Resource>;
  resources: Resource[];
}) => {
  return resources.map((resource) => ({
    value: getSelectValue({
      item: resource,
      valueProp,
    }) as string,
    label: getSelectLabel<Resource>({
      item: resource,
      labelProp,
    }) as string,
    resource,
  }));
};
